import cssHasPseudo from "../../node_modules/css-has-pseudo/dist/browser.mjs";
import "./imports.js";
import "./tables.js";

cssHasPseudo(document);
